<template>
  <Breadcrumbs
      title="Settings"
      :breadcrumbs="[
      { label: 'Settings', path: '/settings' },
    ]"
  />

  <div class="container-fluid ">
      <div class="user-profile">
          <div class="row">
              <changePassword />
          </div>
      </div>
  </div>
</template>

<script>
import changePassword from "./changePassword.vue";

export default {
    name: 'userProfile',
    components: {
        changePassword,
    },

}
</script>
